import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconBeanbag24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="beanbag">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3.5c-3.9 0-6.4 4.3-7.6 8.1C3.2 15.6 4.4 20.5 12 20.5s8.8-4.9 7.6-8.9C18.4 7.8 15.9 3.5 12 3.5zm-4.5 10.6c1.2.9 2.8 1.4 4.5 1.4s3.3-.5 4.5-1.4a.9.9 0 1 1 1.1 1.4c-1.5 1.2-3.5 1.8-5.6 1.8s-4.1-.6-5.6-1.8a.9.9 0 1 1 1.1-1.4z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconBeanbag16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="beanbag">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3.5c-3.9 0-6.4 4.3-7.6 8.1C3.2 15.6 4.4 20.5 12 20.5s8.8-4.9 7.6-8.9C18.4 7.8 15.9 3.5 12 3.5zm-4.5 10.6c1.2.9 2.8 1.4 4.5 1.4s3.3-.5 4.5-1.4a.9.9 0 1 1 1.1 1.4c-1.5 1.2-3.5 1.8-5.6 1.8s-4.1-.6-5.6-1.8a.9.9 0 1 1 1.1-1.4z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
